// extracted by mini-css-extract-plugin
export default {"root":"ResearchMediaError_root__czfwP"};